import "./App.css";
import "./index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Sponsorships from "./pages/Sponsorships";
import SmoothScroll from "./components/SmoothScroll";
import { Toaster } from "sonner";

function App() {
  useEffect(() => {
    // Enforce our own title over any platform-injected default
    const TITLE = "Event Monk | Events, reimagined";
    document.title = TITLE;

    // Ensure favicon links stay applied (platform script strips them)
    const ensureIcon = (rel, href, type, sizes) => {
      let link = document.querySelector(`link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ""}`);
      if (!link) {
        link = document.createElement("link");
        link.rel = rel;
        if (type) link.type = type;
        if (sizes) link.setAttribute("sizes", sizes);
        document.head.appendChild(link);
      }
      if (link.href !== href) link.href = href;
    };
    const applyIcons = () => {
      ensureIcon("icon", "/favicon-32.png", "image/png", "32x32");
      ensureIcon("icon", "/favicon-16.png", "image/png", "16x16");
      ensureIcon("shortcut icon", "/favicon.ico");
      ensureIcon("apple-touch-icon", "/apple-touch-icon.png", null, "180x180");
    };
    applyIcons();

    const t = setInterval(() => {
      if (document.title !== TITLE) document.title = TITLE;
      const b = document.getElementById("emergent-badge");
      if (b) b.style.setProperty("display", "none", "important");
      applyIcons();
    }, 800);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sponsorships" element={<Sponsorships />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </SmoothScroll>
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
